export default "__VITE_ASSET__CRzLoGKC__"